module.exports = __webpack_public_path__ + "img/Modernisme_Tida_og_samfunnsforholdene3.bcc99bdd.jpg";